import React from "react"

import {
    Container,
    PageContent,
} from "client/components"

import DefaultAccountSettings from "./defaultAccountSettings"
import OkrMetric from "./metric"

const Okr = () => (
    <Container>
        <PageContent>
            <DefaultAccountSettings />
            <OkrMetric />
        </PageContent>
    </Container>
)
export default Okr
